import { ReactElement } from 'react';

import { Link } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../../translations';
import { useScheduleOnlyVisibilityPreferenceState } from '../preferences/preferences.storage';

export const TimetablePlaceholderTurnOffPreferencesLink = (): ReactElement => {
   const [, setScheduleOnlyVisibilityPreference] = useScheduleOnlyVisibilityPreferenceState();
   return (
      <Link
         testId={'timetableLimitedViewTurnOffLink'}
         onClick={() => setScheduleOnlyVisibilityPreference(false)}
         label={calendarTranslationKeys.turnOffPreferences}
      />
   );
};
